import apiSlice from "../api/apiSlice";

export const evApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* GET */
    getBatteryStateLoadsByCommunityIdPagination: builder.query({
      query: ({ limit, page, date, time, resourceId, communityId, sortColumn, sortDirection }) => ({
        url:
          `/communities/${communityId}/storage_battery_state_loads/pagination?` +
          `limit=${limit}&` +
          `offset=${page * limit}` +
          `${date ? `&date=${date}` : ""}` +
          `${time ? `&time=${time}` : ""}` +
          `${resourceId ? `&resource_id=${resourceId}` : ""}` +
          `${sortDirection ? `&sort_direction=${sortDirection}` : ""}` +
          `${sortColumn ? `&sort_column=${sortColumn}` : ""}`,
        method: "GET",
      }),
      providesTags: () => [{ type: "Batteries", id: "LIST" }],
    }),
    /* POST */
    addBatteryStateLoads: builder.mutation({
      query: ({ file, communityId }) => {
        const formData = new FormData();

        formData.append("file_upload", file, file.name);

        return {
          url: `/communities/${communityId}/storage_battery_state_loads`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [{ type: "Batteries", id: "LIST" }],
    }),
  }),
});

export const {
  useAddBatteryStateLoadsMutation,
  useGetBatteryStateLoadsByCommunityIdPaginationQuery,
} = evApiSlice;
